import { atom } from "recoil"

export const contacGroupState = atom<boolean>({
  key: "atoms/sidebar/contacGroupState",
  default: false,
})
